import type { FacadeSpec, HouseOpenings, Opening } from './openings';
import type { Lot } from './types';
import { HOGE_HUIS } from './surveyed/hogeHuisPlan';

/** These exposed yard windows are estimates; the images do not resolve a complete elevation. */
export function hogeHuisOpenings(
  lot: Lot,
  spec: FacadeSpec,
  ordinary: HouseOpenings
): HouseOpenings {
  const house = HOGE_HUIS.houses.find((h) => h.id === lot.reconstruction?.id);
  if (
    !house ||
    Math.abs(lot.depth - house.depth) > 0.001 ||
    Math.abs(spec.width - house.width) > 0.001
  )
    return ordinary;
  const { fromFront, width, height, sill } = house.yardWindows;
  const windows: Opening[] = [];
  for (const at of fromFront) {
    // Party-wall coverage is measured from the back corner; wall openings from the front.
    const x = at - width / 2,
      backFrom = spec.length - x - width,
      backTo = spec.length - x;
    if (spec.party.covered.right.some(([a, b]) => backFrom < b && backTo > a)) continue;
    for (let i = 0; i < spec.storeys; i++)
      windows.push({ kind: 'smallWindow', x, y: i * spec.storeyHeight + sill, width, height });
  }
  return { ...ordinary, right: windows };
}
